import { render, staticRenderFns } from "./durjuram.vue?vue&type=template&id=a9485c00&scoped=true&"
import script from "./durjuram.vue?vue&type=script&lang=js&"
export * from "./durjuram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9485c00",
  null
  
)

export default component.exports